<template>
  <ykc-form :model="ruleForm" :rules="rules" ref="ruleForm" class="el-form-wrap">
    <ykc-form-item>
      <span class="label">【电站详情】</span>
    </ykc-form-item>
    <ykc-form-item class="display-flex">
      <ykc-form-item>
        <div style="display: flex; justify-content: space-between; width: 200%">
          <div style="width: 50%">
            <span class="label">电站名称:</span>
            <span class="value">
              {{ ruleForm.stationName ? ruleForm.stationName : '电站名称' }}
            </span>
          </div>
          <div style="width: 50%">
            <span class="label">电站编码:</span>
            <span class="value">
              {{ ruleForm.stationCode ? ruleForm.stationCode : '电站编码' }}
            </span>
          </div>
        </div>
      </ykc-form-item>
      <ykc-form-item>
        <span class="label" style="justify-content: space-between">是否参与运营活动:</span>
        <span class="value">{{ ruleForm.isJoinActivity }}</span>
      </ykc-form-item>
      <ykc-form-item label="是否参与会员卡优惠" prop="isJoinVip">
        <ykc-radio
          :data="[
            { id: 0, name: '否' },
            { id: 1, name: '是' },
          ]"
          v-model="ruleForm.isJoinVip"></ykc-radio>
      </ykc-form-item>
    </ykc-form-item>
    <priceDisplay ref="priceDisplay" :priceData="priceData" :isJoinVip="ruleForm.isJoinVip === 1" />

    <!-- <YkcDetailPlus class="box-card" :labelWidth="150">
      <div slot="header" class="clearfix">
        <span>【抽成费用概况】</span>
      </div> -->
    <!-- </YkcDetailPlus> -->
    <ykc-form-item label="【抽成费用概况】"></ykc-form-item>
    <YkcDetailItemPlus label="是否收取抽成:">
      {{ ruleForm.isCommission }}
    </YkcDetailItemPlus>
    <YkcDetailItemPlus label="电费抽成:">
      {{ ruleForm.powerCommission ? `${ruleForm.powerCommission}元/度` : '——' }}
    </YkcDetailItemPlus>
    <YkcDetailItemPlus label="服务费抽成:">
      {{
        ruleForm.isCommission === '是'
          ? ruleForm.serviceCommission
            ? ruleForm.serviceCommission
            : 0
          : '——'
      }}
    </YkcDetailItemPlus>
    <YkcDetailItemPlus label="电站合同:">
      <div v-if="ruleForm.contract.name">
        <span type="files" style="margin-right: 10px; color: blue">
          {{ ruleForm.contract.name ? ruleForm.contract.name : '' }}
        </span>
        <div style="width: 30px; display: inline-block">
          <ykc-button type="text" @click="downloadContract(ruleForm.contract)">下载</ykc-button>
        </div>
      </div>
      <div v-else>——</div>
    </YkcDetailItemPlus>
    <div style="display: flex; justify-content: space-between; width: 100%">
      <div style="width: 30%">
        <YkcDetailItemPlus label="租金:">
          {{ ruleForm.rentAmount ? `${ruleForm.rentAmount}元/年` : '——' }}
        </YkcDetailItemPlus>
      </div>
      <div style="width: 30%">
        <YkcDetailItemPlus label="抽成保底金额:">
          {{ ruleForm.commissionBottomAmount ? `${ruleForm.commissionBottomAmount}元/度` : '——' }}
        </YkcDetailItemPlus>
      </div>
      <div style="width: 30%">
        <YkcDetailItemPlus label="赞助费:">
          {{ ruleForm.sponsorshipFee ? `${ruleForm.sponsorshipFee}元/年` : '——' }}
        </YkcDetailItemPlus>
      </div>
    </div>
    <div style="display: flex; justify-content: space-between; width: 100%">
      <div style="width: 30%">
        <YkcDetailItemPlus label="渠道分成:">
          {{ ruleForm.channelSharingName ? `${ruleForm.channelSharingName}` : '——' }}
        </YkcDetailItemPlus>
      </div>
      <div style="width: 30%">
        <YkcDetailItemPlus label="电费上浮比例:">
          {{ ruleForm.powerFeeRatio ? `${ruleForm.powerFeeRatio}%` : '——' }}
        </YkcDetailItemPlus>
      </div>
      <div style="width: 30%">
        <YkcDetailItemPlus label="电费上浮价格:">
          {{ ruleForm.powerFeePrice ? `${ruleForm.powerFeePrice}元/度` : '——' }}
        </YkcDetailItemPlus>
      </div>
    </div>
    <div style="display: flex; justify-content: space-between; width: 100%">
      <div style="width: 100%">
        <YkcDetailItemPlus label="其他合同费项:" width="30%">
          {{ ruleForm.otherContract ? ruleForm.otherContract : '——' }}
        </YkcDetailItemPlus>
      </div>
    </div>
    <!-- <div class="clearfix" slot="header">
      <span>【兜底价信息】</span>
    </div> -->
    <ykc-form-item label="【兜底价信息】">
      <YkcDetailItemPlus label="电站兜底服务费:"></YkcDetailItemPlus>
      <ykc-form-item prop="ensureServiceRate" label-width="20%">
        <div style="align-items: center">
          <ykc-input
            v-model="ruleForm.ensureServiceRate"
            placeholder=""
            placeholder-class="input-placeholder"
            style="width: 10%"
            @blur="$refs.ruleForm.validateField('ensureServiceRate')" />
          <span style="margin-left: 10px">元/度</span>
        </div>
      </ykc-form-item>
    </ykc-form-item>
  </ykc-form>
</template>

<script>
  import { chargeVipPriceFee, uploadUtils } from '@/service/apis';
  import regexpObj from '@/utils/regexp';
  import priceDisplay from '@/components/dynamic-compose/price-display.vue';
  import YkcFormItem from '@/components/ykc-ui/form/src/ykc-form-item.vue';

  export default {
    props: ['currentRow', 'operateType', 'selectedRows'],
    components: { priceDisplay, YkcFormItem },
    data() {
      return {
        priceData: { feeList: [], priceList: [] },
        rules: {
          ensureServiceRate: [
            {
              required: true,
              message: '请输入电站兜底服务费',
              trigger: 'blur',
            },
            {
              trigger: 'blur',
              pattern: regexpObj.regexp.input.amountNumberType.regexp,
              message: regexpObj.regexp.input.amountNumberType.errorTips.error(
                '电站兜底服务费',
                999999999.99
              ),
            },
          ],
        },
        ruleForm: {
          configType: '0', // 配置方式 【0：手动配置 1：引用其它站点 2：引用价格模板】
          priceType: '0', // 费率类别 0-尖峰平谷、1-48费率
          templateId: '', // 模版Id
          feeList: [], // 价格组集合
          priceList: [], // 充电费用集合
          useTime: '', // 价格生效时间，定时生效时有值
          isJoinActivity: 1, // 是否参与运营活动
          isJoinVip: 1, // 是否参与会员卡优惠
          contract: {}, // 合同列表
          // 抽成费用相关字段
          isCharge: false, // 是否收取抽成
          rentAmount: null, // 租金
          guaranteeAmount: null, // 抽成保底金额
          sponsorshipFee: null, // 赞助费
          channelSharingType: null, // 渠道分成类型
          channelSharingValue: null, // 渠道分成值
          powerFeeRatio: null, // 电费上浮比例
          powerFeePrice: null, // 电费上浮价格
          otherContract: null, // 其他合同费项
          channelSharingName: null, // 渠道分成名称
          ensureServiceRate: null, // 电站兜底服务费
          isCommission: null,
          contractAttachment: null,
        },
        isJoinActivity: '1',
        effectiveType: '0', // 生效方式
      };
    },
    watch: {
      'ruleForm.priceList': {
        deep: true,
        handler() {
          this.$refs.ruleForm && this.$refs.ruleForm.validateField('priceList');
        },
      },
    },
    created() {
      if (this.operateType === 'single') {
        // 填充详情数据到表单
        if (this.currentRow) {
          console.log('this.currentRow+++', this.currentRow);
          this.ruleForm = { ...this.ruleForm, ...this.currentRow };
          const contractInfo = this.currentRow.stationVipContractInfo || [];
          this.ruleForm.powerCommission = contractInfo.powerCommission;
          this.ruleForm.serviceCommission = contractInfo.serviceCommission;
          this.ruleForm.rentAmount = contractInfo.rentAmount;
          this.ruleForm.commissionBottomAmount = contractInfo.commissionBottomAmount;
          this.ruleForm.sponsorshipFee = contractInfo.sponsorshipFee;
          this.ruleForm.channelSharingType = contractInfo.channelSharingType;
          this.ruleForm.channelSharingValue = contractInfo.channelSharingValue;
          this.ruleForm.powerFeeRatio = contractInfo.powerFeeRatio;
          this.ruleForm.channelSharingName = contractInfo.channelSharingName;
          this.ruleForm.powerFeePrice = contractInfo.powerFeePrice;
          this.ruleForm.otherContract = contractInfo.otherContract;
          this.ruleForm.bottomServiceFee = contractInfo.bottomServiceFee;
          this.ruleForm.isCommission = contractInfo.isCommission;
          if (contractInfo.contractAttachment) {
            this.ruleForm.contract = {
              name: contractInfo.attachmentName,
              url: contractInfo.contractAttachment,
            };
          }
          console.log('this.ruleForm+++', this.ruleForm);

          this.priceData = {
            feeList: this.currentRow.stationVipCardInfoDTOJfpgList || [],
            priceList: this.currentRow.stationVipCardInfoDTOTimeJfpgList || [],
          };
          console.log('this.priceData+++', this.priceData);
        }
      } else {
        this.resetPriceData();
      }
    },
    methods: {
      /**
       * 获取渠道分成类型标签
       */
      getChannelSharingTypeLabel(type) {
        const types = {
          1: '比例',
          2: '度数',
          3: '小时',
          4: '次数',
        };
        return types[type] || '比例';
      },

      /**
       * 获取渠道分成类型单位
       */
      getChannelSharingTypeUnit(type) {
        const units = {
          1: '%',
          2: '元/度',
          3: '元/小时',
          4: '元/次',
        };
        return units[type] || '%';
      },

      /** 导入文件 */
      uploadFile(file, fileList, isCheck) {
        console.log(file, fileList, isCheck);
        // 检查file是否存在
        if (!file) {
          this.$message.error('文件对象不存在');
          return;
        }

        if (isCheck) {
          const formData = new FormData();
          const param = {
            file: file.raw,
            bizName: '',
          };
          console.log('param', param);
          // 处理入参格式
          Object.entries(param).forEach(([k, v]) => {
            formData.append(k, v);
          });
          uploadUtils.uploadFile(formData).then(res => {
            this.ruleForm.contractDTO.contractAttachment = res;
            this.ruleForm.contractDTO.attachmentName = file.name || '未知文件';
            this.$refs.contractAttachment.fileList = [
              {
                name: file.name || '未知文件',
                url: res,
              },
            ];
            this.$refs.ruleForm2.validateField('contractDTO.contractAttachment');
          });
        }
      },

      /**
       * 下载合同
       */
      downloadContract(file) {
        console.log('Downloading contract:', file);
        // 检查文件对象是否存在
        if (!file) {
          this.$message.warning('文件对象不存在');
          return;
        }

        // 直接下载文件
        if (file.url) {
          // 检查URL是否有效
          if (file.url.startsWith('http://') || file.url.startsWith('https://')) {
            const link = document.createElement('a');
            link.href = file.url;
            link.download = file.name || 'contract.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            // 如果URL没有协议前缀，尝试添加https://
            const fullUrl = file.url.startsWith('//') ? `https:${file.url}` : `https://${file.url}`;
            const link = document.createElement('a');
            link.href = fullUrl;
            link.download = file.name || 'contract.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        } else {
          this.$message.warning('无法下载文件：文件链接不存在');
        }
      },

      /**
       * 重置尖峰平谷数据
       */
      resetPriceData() {
        this.priceData = {
          feeList: [],
          priceList: [],
        };
      },
      /**
       * 提交
       */
      submitForm(callback) {
        console.log('this.ruleForm+++', this.ruleForm);
        if (this.ruleForm.priceType === '0') {
          this.PeaksValleysFun(callback);
        }
      },
      /**
       * 尖峰平谷提交
       */
      PeaksValleysFun(callback) {
        console.log(
          'this.$refs.priceDisplay.saveVerifyOMP()+++',
          this.$refs.priceDisplay.saveVerifyOMP()
        );
        const promisify = item =>
          new Promise(resolve => {
            item.validate(valid => {
              resolve(valid);
            });
          });
        Promise.all([promisify(this.$refs.ruleForm)]).then(res => {
          if (res.every(valid => !!valid)) {
            // 添加服务费价格验证
            const peaksData = this.$refs.priceDisplay.saveVerifyOMP();

            // 验证基础服务费 >= 会员卡服务费 且 < 平台活动服务费
            const isValid = true;
            const errorMessage = '';
            const vipPriceFeeDTOList = {};
            const vipPriceDTO = [];
            if (peaksData && peaksData.feeList) {
              for (let i = 0; i < peaksData.feeList.length; i++) {
                const feeItem = peaksData.feeList[i];
                const feeType = Number(feeItem.feeType);
                const serviceRate = Number(feeItem.serviceRate || 0); // 基础服务费
                const vipServiceRate = Number(feeItem.vipServiceRate || 0); // 会员卡服务费
                vipPriceDTO.push({
                  feeType,
                  vipServiceRate,
                });
              }
            }
            vipPriceFeeDTOList.vipPriceDTO = vipPriceDTO;
            console.log('vipPriceFeeDTO+++', vipPriceFeeDTOList);

            if (this.operateType === 'single') {
              console.log('this.currentRow+++', this.currentRow);
              const parameter = {
                stationId: this.currentRow.stationId,
                ensureServiceRate: this.ruleForm.ensureServiceRate,
                isJoinVip: this.ruleForm.isJoinVip,
                vipPriceFeeDTO: vipPriceFeeDTOList,
              };
              console.log('parameter+++', parameter);
              console.log('this.currentRow+++', this.currentRow);
              if (this.currentRow.isConfig === 1) {
                chargeVipPriceFee.edit(parameter).then(response => {
                  console.log('chargeVipPriceFee single edit', response);
                  callback();
                });
              } else {
                chargeVipPriceFee.add(parameter).then(response => {
                  console.log('chargeVipPriceFee multiple edit', response);
                  callback();
                });
              }
            } else if (this.operateType === 'multiple') {
              const parameter = {
                periodType: '1', // 时段类型 固定传1
                stationIds: this.selectedRows.map(({ stationId }) => stationId),
                ensureServiceRate: this.currentRow.ensureServiceRate,
                isJoinVip: this.currentRow.isJoinVip,
                ...this.ruleForm,
                vipPriceFeeDTO: vipPriceFeeDTOList,
              };
              chargeVipPriceFee.batchEdit(parameter).then(response => {
                console.log('chargeVipPriceFee multiple edit', response);
                callback();
              });
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  ._line {
    display: flex;
    flex-direction: row;
  }
  .display-flex {
    font-size: 20px;
    display: flex;
    flex-direction: row;
  }
  .fee-display {
    width: 30%;
    display: flex;
    flex-direction: row;
  }
</style>
